import { onBeforeUnmount } from 'vue';
import { debounce } from 'lodash-es';
import { useUserEnvStore } from '@/common/stores/user-env';
import { TabPanel } from '@/common/utils/types';

export const usePersistedTab = (key: string) => {
  const envStore = useUserEnvStore();

  const getSavedTab = (
    options: {
      panels?: Readonly<TabPanel<string>[]> | TabPanel<string>[];
      value?: string;
    } = {},
  ): string => {
    const stored = envStore.getEnvValue<string>(key);
    const { panels, value: fallback } = options;

    if (panels) {
      if (typeof stored === 'string' && panels.some((p) => p.value === stored)) {
        return stored;
      }

      return panels[0]?.value ?? fallback ?? '';
    }

    return stored ?? fallback ?? '';
  };

  const saveTab = debounce((value: string) => {
    if (!value) {
      return;
    }

    envStore.setEnvValue([{ key, value }]);
  }, 300);

  onBeforeUnmount(() => saveTab.flush());

  return { getSavedTab, saveTab };
};
